import React from 'react';
import { Box, Typography, Button, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';

const NotFoundScreen: React.FC = () => {
    const theme = useTheme()
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                textAlign: 'center',
            }}
        >
            <Typography variant="h1" component="h1" gutterBottom>
                404
            </Typography>
            <Typography variant="h4" component="h2" gutterBottom>
                Page Not Found
            </Typography>
            <Typography variant="body1" paragraph>
                The page you are looking for doesn't exist or has been moved.
            </Typography>
            <Button component={Link} to="/" variant="contained" color="primary"
                sx={{
                    mt: 3,
                    mb: 2,
                    bgcolor: "success.main",
                    "&:hover": {
                        bgcolor: "success.dark",
                    },
                    color: theme.palette.secondary.main,
                }}>
                Go to Home
            </Button>
        </Box>
    );
};

export default NotFoundScreen;